export function invokeIf<TValue>(
  predicate: boolean | (() => boolean),
  fcn: (...args: TValue[]) => void,
  args: Parameters<typeof fcn> = []
): void {
  const callPredicate = typeof predicate === 'function' ? predicate() : predicate

  if (callPredicate) {
    fcn(...args)
  }
}
